import { Actions } from '../../interfaces'
import { AutomotiveRegistration } from '@/entities/vehicle'

import find from './find'

export const actions: Actions = {
  find,
}

export default {
  Model: { AutomotiveRegistration },
  actions: { [AutomotiveRegistration.name]: actions },
}
